import React from 'react';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

export default [
  { id: 'code' },
  {
    header: <TranslatedCopy id='global.requested' />,
    id: 'totalRequestedQty'
  },
  {
    header: <TranslatedCopy id='global.confirmed' />,
    id: 'totalConfirmedQty'
  },
  {
    header: <TranslatedCopy id='global.shipped' />,
    id: 'totalShippedQty'
  },
  {
    header: <TranslatedCopy id='global.reference' />,
    id: 'totalOpenReferenceQty'
  },
  {
    header: <TranslatedCopy id='global.reserved' />,
    id: 'totalReservedQty'
  },
  {
    header: <TranslatedCopy id='global.cancelled' />,
    id: 'totalCancelledQty'
  }
];
